module.exports = __webpack_public_path__ + "static/media/red_writing_hours.73c7ce33.svg";